const boxModelCorrection = (container, axis) => {
  const allGroups = Array.from(container.children);
  const firstGroupBounds = allGroups[0].getBoundingClientRect();
  const itemContainerBounds = container.getBoundingClientRect();

  return axis === 'y' ? firstGroupBounds.y - itemContainerBounds.y : firstGroupBounds.x - itemContainerBounds.x;
};

export default boxModelCorrection;
